import React, { Fragment } from 'react';

import useTeamFacilityPoolDetail from './UseTeamFacilityPoolDetail';

import NavLinks from '../NavLinks';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import AddEditFacilityPool from '@usas/ui-web/components/searches/searchFacility/addEditPool/AddEditFacilityPool';
import Constants from '@usas/ui-web/utils/Constants';

const TeamFacilityPoolDetail = () => {
  const {
    teamState
  } = useTeamFacilityPoolDetail();

  return (
    <Fragment>
      <AddEditFacilityPool
        saveUrl={NavLinks.TEAM_FACILITY}
        cancelUrl={NavLinks.TEAM_FACILITY}
        showFacilityInfo={true} />
      <div className="row">
        <div className="col-xs-12 usas-extra-bottom-margin"></div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={teamState.isSaving} />
    </Fragment>
  );
};

export default TeamFacilityPoolDetail;